import React, { useState, useEffect } from 'react';
import '../style.css';

const HeroSection = () => {
  // Image URLs for the banner
  const bannerImages = [
    'banner.png',
    'banner1.png',
    'banner3.png'
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [imageError, setImageError] = useState(false);

  // Handle image error
  const handleImageError = () => {
    setImageError(true);
  };

  // Auto-change banner every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => 
          prevIndex === bannerImages.length - 1 ? 0 : prevIndex + 1
        );
        setFade(true);
        setImageError(false);
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, [bannerImages.length]);

  // Manual navigation
  const goToNext = () => {
    setFade(false);
    setTimeout(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === bannerImages.length - 1 ? 0 : prevIndex + 1
      );
      setFade(true);
      setImageError(false);
    }, 300);
  };

  const goToPrev = () => {
    setFade(false);
    setTimeout(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === 0 ? bannerImages.length - 1 : prevIndex - 1
      );
      setFade(true);
      setImageError(false);
    }, 300);
  };

  const goToSlide = (index) => {
    setFade(false);
    setTimeout(() => {
      setCurrentImageIndex(index);
      setFade(true);
      setImageError(false);
    }, 300);
  };

  return (
    <section className="hero-section">
      {/* Background Image Slider */}
      <div className="hero-slider">
        <div className={`slide ${fade ? 'fade-in' : 'fade-out'}`}>
          {!imageError ? (
            <img 
              src={bannerImages[currentImageIndex]} 
              alt={`NeuroCare Banner ${currentImageIndex + 1}`}
              className="hero-image"
              onError={handleImageError}
            />
          ) : (
            <div className="image-fallback">
              <div className="fallback-gradient"></div>
            </div>
          )}
        </div>
        
        {/* Overlay gradient */}
        <div className="hero-overlay"></div>
      </div>

      

      {/* Slider Controls - Mobile me chhota */}
      <button className="slider-btn prev" onClick={goToPrev}>
        <span className="arrow">←</span>
      </button>
      <button className="slider-btn next" onClick={goToNext}>
        <span className="arrow">→</span>
      </button>

      {/* Dots Indicator */}
      <div className="slider-dots">
        {bannerImages.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentImageIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Scroll Indicator - Mobile me hide */}
      <div className="scroll-indicator">
        <div className="scroll-line"></div>
        <div className="scroll-text">Scroll</div>
      </div>
    </section>
  );
};

export default HeroSection;